import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, imgUrl, formatDate } from "@/lib/api";
import Prose from "@/components/Prose";
import ShareButton, { usePageMeta } from "@/components/Share";
import NotFound from "@/pages/NotFound";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(undefined);
  useEffect(() => {
    api.get(`/public/articles/${slug}`).then(({ data }) => setA(data)).catch(() => setA(null));
  }, [slug]);
  usePageMeta(a?.title, a?.excerpt);
  if (a === undefined) return <p className="max-w-7xl mx-auto px-8 pt-20 text-sm text-[#5a665e]">Loading…</p>;
  if (a === null) return <NotFound />;

  return (
    <article data-testid="article-detail-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-10 sm:pt-14">
        <Link to="/articles" className="inline-flex items-center gap-2 text-sm text-[#5a665e] hover:text-[#1f402b]" data-testid="article-back-link"><ArrowLeft size={14} /> All articles</Link>
        <p className="mt-10 eyebrow">{a.category} · {formatDate(a.created_at)}</p>
        <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[#1a261f]" data-testid="article-title">{a.title}</h1>
        <p className="mt-6 text-lg sm:text-xl text-[#5a665e] leading-relaxed font-display italic">{a.excerpt}</p>
        {a.author && <p className="mt-6 font-mono-k text-[11px] text-[#5a665e]">By {a.author}</p>}
        <div className="mt-6"><ShareButton kind="articles" slug={a.slug} title={a.title} /></div>
      </div>
      {a.cover_image && (
        <div className="max-w-6xl mx-auto px-5 sm:px-8 mt-12">
          <img src={imgUrl(a.cover_image)} alt={a.title} className="w-full aspect-[16/8] object-cover" />
        </div>
      )}
      <div className="max-w-2xl mx-auto px-5 sm:px-8 mt-14">
        <Prose text={a.body} />
      </div>
    </article>
  );
}
